/**
 *
 * @param {String} parent
 * @param {Map<String, Map<String, String>>} applied
 * @param {Array<String>} unordered
 * @param {Boolean} isInitial
 */
const fillAppliedInitials = (parent, applied, unordered, isInitial) => {
  if (isInitial) {
    return;
  }
  const appliedParent = /** @type {Map<String, String>} */ (
    applied.get(parent)
  );

  if (!appliedParent) {
    return;
  }

  for (const initial of appliedParent.values()) {
    unordered.unshift(initial);
  }
};

export default fillAppliedInitials;
